export const alertConstants = {
  SUCCESS: 'LOGIN:SUCCESS',
  ERROR: 'LOGIN:ERROR',
  CLEAR: 'LOGIN:CLEAR'
};